import { Component, OnInit } from '@angular/core';
import {Observable, of, Subscription} from "rxjs";
import { FeedbackComplaint } from "../../../store/entities/feedback/feedback.model";
import { Store } from "@ngrx/store";
import { AppState } from "../../../store/reducers";
import { getMyServiceFeedbackComplaints } from "../../../store/entities/feedback/feedback.actions";
import { selectModifiedFeedbacks } from "../../../store/entities/feedback/feedback.selectors";
import {TrackComplaintModel, TrackComplaintsService} from "../../../services/track-complaint.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-tgsd-client-feedback',
  templateUrl: './tgsd-client-feedback.component.html',
  styleUrl: './tgsd-client-feedback.component.scss'
})
export class TgsdClientFeedbackComponent implements OnInit {
  tableColumns: any;
  myFeedbacks: Observable<FeedbackComplaint[]>;

  currentClient: string;
  complaintTracking: TrackComplaintModel;
  trackNumber: string = ''; // Track number input value
  routeSub = Subscription.EMPTY;

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<AppState>,
    private trackingService: TrackComplaintsService
  ) {}

  ngOnInit(): void {
    this.currentClient = localStorage.getItem('currentClient');
    this.routeSub = this.activatedRoute.paramMap.subscribe(items => {
      this.trackNumber = items.get('trackingId') as any;
      console.log(this.trackNumber);

      this.trackComplaint();
    });

    this.tableColumns = {
      no: 'SN',
      trackNumber: of("Kumbukumbu Namba ya Mrejesho"),
      feedbackType: of("Aina ya Mrejesho"),
      title: of("Kichwa cha Mrejesho"),
      modFeedbackService: of("Jina la Huduma"),
      location: of("Eneo la Mrejesho"),
      action: of("Actions"),
    };

    this.store.dispatch(getMyServiceFeedbackComplaints({
      filtering: {
        pageNumber: 1
      }
    }));

    this.myFeedbacks = this.store.select(selectModifiedFeedbacks);
  }

  trackComplaint() {
    if (!this.trackNumber) {
      console.error("Track number cannot be empty!");
      return;
    }

    this.trackingService.trackComplaint(this.trackNumber).subscribe({
      next: (data) => {
        this.complaintTracking = data; // Store the tracking result
      },
      error: (err) => {
        console.error('Error tracking complaint:', err);
      },
    });
  }

  closeView() {
    this.trackNumber = ''
    this.complaintTracking = null
  }
}
